// extracted by mini-css-extract-plugin
export default {"messageLayout":"MessagePage_messageLayout__lwY4l","messageImg":"MessagePage_messageImg__qc2kN"};